// extracted by css-extract-rspack-plugin
export default {"root":"root-3ukkj","large":"large-EyXoi","small":"small-2qaB_","focus-outline":"focus-outline-3WyPz"};